import { makeStyles } from '@material-ui/core';

const DataPolicyTaskDetailsStyles = makeStyles((theme) => {

    return ({
        buttoncontainer: {
            display: 'flex',
            justifyContent: 'space-between',
            fontFamily: 'Arial',
            position: 'fixed',
            bottom: 0,
            right: 0,
            width: 'calc(100% - 236px)',
            padding: '1em',
            boxShadow: '0px -1px 4px 0px rgba(0, 0, 0, 0.15)',
            background: '#FFF',
            zIndex: 1,
            '& > div:only-child': {
              marginLeft: 'auto'
            },
            [theme.breakpoints.between('xs', 'sm')]: {
              width: '100%'
            }
        },
        container: {
            padding: '0 36px',
            borderRadius: '4px',
            marginBottom: '30px'
        },
        button: {
            maxWidth: '20rem',
        },
        backButton: {
            boxShadow: '0 0 0 2px inset var(--azure)',
            backgroundColor: 'var(--white)',
            color: '#007DB8',
            width: '150px',
            height: '30px'
        },
        btn_primary: {
            color: 'var(--white)',
            backgroundColor: 'var(--teal-blue)',
            '&:hover': {
              color: 'var(--white)',
              backgroundColor: 'var(--teal-blue)',
            }
          },
          boxContent : {
            padding: '25px !important'
        },
        contentText : {
            fontWeight: 500,
          },
          titleIcon: {
        color: 'var(--warning-orange)',
        verticalAlign: "bottom",
        paddingRight: '5px'
      }
    });
});

export default DataPolicyTaskDetailsStyles;
